import React, { Component } from 'react';
import {Card, CardActions, CardTitle, CardText} from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

class MentorCard extends Component {

  constructor(props) {
    super(props);
  }
  render() {
    return (
      <MuiThemeProvider>
      <Card className="mentor-card">
        <CardTitle title={this.props.mentorName} subtitle={this.props.mentorTitle} />
        <CardText>
            {this.props.mentorMessage}
        </CardText>
        <CardActions>
        { this.props.mentorTwitter && <FlatButton href={this.props.mentorTwitter} target='_blank' label={<i className="fa fa-twitter fa-2x" aria-hidden="true"></i>} />}
        { this.props.mentorEmail && <FlatButton href={"mailto:" + this.props.mentorEmail} target='_blank' label={<i className="fa fa-envelope fa-2x" aria-hidden="true"></i>} />}
        </CardActions>
    </Card>
  </MuiThemeProvider>
    );
  }
}

export default MentorCard;


// WEBPACK FOOTER //
// ./src/components/MentorCard.js